import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import React, { useState } from "react"
import { Scenario } from "@/gen"
import dayjs from "dayjs"
import { ExecutionNodeInputOutput } from "./ExecutionNodeInputOutput"

interface ExecutionNodesSheetProps {
  children: React.ReactNode
  scenario: Scenario
  execution: any
}

export function ExecutionNodesSheet(props: ExecutionNodesSheetProps) {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{props.children}</SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>
            Execução <span className="text-sm text-secondary">#{props.execution.id}</span>
          </SheetTitle>
          <SheetDescription></SheetDescription>
        </SheetHeader>
        {open && <ExecutionNodesSheetContent {...props} />}
      </SheetContent>
    </Sheet>
  )
}

function ExecutionNodesSheetContent(props: ExecutionNodesSheetProps) {
  return (
    <div className="px-4">
      {props.execution.trail?.map((trailNode) => (
        <ExecutionNodeInputOutput
          key={trailNode.node_id + trailNode.started_at}
          execution={props.execution}
          scenario={props.scenario}
          nodeId={trailNode.node_id}
        >
          <a
            key={trailNode.node_id}
            onClick={() => {}}
            className="bg-ground rounded-2xl p-4 flex flex-col gap-1 text-xs mb-1 cursor-pointer hover:bg-ground-active"
          >
            <span>
              <b>Node</b> #{trailNode.node_id}
            </span>
            <span>
              <b>Started at:</b> {dayjs(trailNode.started_at).format("DD/MM/YYYY HH:mm:ss")}
            </span>
            <span>
              <b>Ended at:</b> {dayjs(trailNode.ended_at).format("DD/MM/YYYY HH:mm:ss")}
            </span>
            {trailNode.retry_attempts && (
              <span>
                <b>Retry attempts:</b> {trailNode.retry_attempts}
              </span>
            )}
          </a>
        </ExecutionNodeInputOutput>
      ))}
    </div>
  )
}
